/* Dream Facet – Valencia product page (Canturi-style)
 * Loaded ONLY by sections/df-valencia-pdp.liquid, which only the
 * product.valencia-canturi-style template uses. Does nothing on any other page.
 *
 * 1. Mounts the Buy Now button beside Add to cart and the info blocks into the
 *    right-hand column of the theme's own main-product section.
 * 2. Buy Now: reads the variant + quantity from the theme's product form,
 *    POSTs to Shopify's native /cart/add.js, then goes to /checkout.
 * 3. Gallery: shows only the media whose alt text names the selected metal tone
 *    (yellow / rose / white). Media without a tone in its alt is always shown.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-df-pdp]');
  if (!root || root.dataset.dfInit === '1') return;
  root.dataset.dfInit = '1';

  var ROUTE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- locate the theme's main product section (never quick view) ---------- */
  function findForm() {
    return document.querySelector('form[id^="product-form-template--"][id$="__main"]');
  }

  function ctx() {
    var form = findForm();
    if (!form) return null;
    /* form.id is shadowed by the form's <input name="id">, so read the attribute */
    var formId = form.getAttribute('id');
    var sid = formId.replace('product-form-', '');
    return {
      sid: sid,
      form: form,
      formId: formId,
      section: document.getElementById('shopify-section-' + sid),
      gallery: document.getElementById('x-product-' + sid),
      atc: document.getElementById('x-atc-button-' + sid),
      buyBlock: document.querySelector('#shopify-section-' + sid + ' .x-block-buy-buttons')
    };
  }

  /* ---------------------------------- mounting ---------------------------------- */
  var buyNow = null;
  var info = root.querySelector('[data-df-info]');

  function mount() {
    var c = ctx();
    if (!c || !c.buyBlock) return false;
    var parent = c.buyBlock.parentElement;

    if (!buyNow) {
      var tpl = root.querySelector('[data-df-buy-now-template]');
      buyNow = tpl.content.firstElementChild.cloneNode(true);
      bindBuyNow(buyNow);
    }
    if (buyNow.previousElementSibling !== c.buyBlock) {
      c.buyBlock.insertAdjacentElement('afterend', buyNow);
    }
    if (info && info.parentElement !== parent) {
      parent.appendChild(info);
      info.classList.add('df-info--mounted');
    }
    document.body.classList.add('df-valencia-pdp');
    syncAvailability();
    return true;
  }

  /* --------------------------------- Buy Now ----------------------------------- */
  var busy = false;

  function setError(msg) {
    var el = buyNow && buyNow.querySelector('[data-df-buy-now-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function setBusy(on) {
    busy = on;
    var btn = buyNow.querySelector('[data-df-buy-now-btn]');
    btn.classList.toggle('is-loading', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.disabled = on || isUnavailable();
  }

  function isUnavailable() {
    var c = ctx();
    if (!c || !c.atc) return false;
    return c.atc.disabled || c.atc.getAttribute('data-available') === 'false';
  }

  var lastOff = null;
  function syncAvailability() {
    if (!buyNow) return;
    var btn = buyNow.querySelector('[data-df-buy-now-btn]');
    var off = isUnavailable();
    btn.disabled = busy || off;
    btn.setAttribute('aria-disabled', off ? 'true' : 'false');
    buyNow.classList.toggle('is-unavailable', off);
    /* clear an "unavailable" message only when the selection becomes available again;
       a failed add-to-cart message stays until the shopper changes an option or retries */
    if (lastOff === true && !off && !busy) setError('');
    lastOff = off;
  }

  function readSelection(c) {
    var idInput = c.form.querySelector('input[name="id"]');
    var qtyInput =
      document.getElementById('Quantity-atc-' + c.sid) ||
      document.querySelector('input[name="quantity"][form="' + c.formId + '"]') ||
      c.form.querySelector('input[name="quantity"]');
    var qty = parseInt(qtyInput && qtyInput.value, 10);
    return {
      id: idInput ? parseInt(idInput.value, 10) : NaN,
      quantity: isNaN(qty) || qty < 1 ? 1 : qty
    };
  }

  function bindBuyNow(el) {
    el.querySelector('[data-df-buy-now-btn]').addEventListener('click', function (e) {
      e.preventDefault();
      if (busy) return;
      var c = ctx();
      if (!c) return;
      setError('');

      if (isUnavailable()) {
        setError('This combination is currently unavailable. Please choose another option.');
        return;
      }
      var sel = readSelection(c);
      if (!sel.id) {
        setError('Please select all options before continuing.');
        return;
      }

      setBusy(true);
      fetch(ROUTE + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: sel.id, quantity: sel.quantity }] })
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok) {
              throw new Error(data.description || data.message || 'We could not add this item to your cart.');
            }
            return data;
          });
        })
        .then(function () {
          window.location.assign(ROUTE + 'checkout');
        })
        .catch(function (err) {
          setBusy(false);
          setError((err && err.message) || 'Something went wrong. Please try again.');
        });
    });
  }

  /* ------------------------------ gallery by metal ------------------------------- */
  var toneOption = (root.getAttribute('data-df-tone-option') || '').trim().toLowerCase();

  function toneOf(text) {
    var t = (text || '').toLowerCase();
    if (/yellow/.test(t)) return 'yellow';
    if (/rose|pink/.test(t)) return 'rose';
    if (/white|platinum|silver/.test(t)) return 'white';
    return null;
  }

  function selectedTone(c) {
    if (!toneOption) return null;
    var radios = c.section ? c.section.querySelectorAll('input[type="radio"]:checked') : [];
    for (var i = 0; i < radios.length; i++) {
      var name = (radios[i].name || '').trim().toLowerCase();
      if (name.indexOf(toneOption + '-') === 0) return toneOf(radios[i].value);
    }
    var sel = c.section && c.section.querySelector('select[name^="' + toneOption + '" i]');
    return sel ? toneOf(sel.value) : null;
  }

  function mediaKey(el) {
    var id = el.getAttribute('data-media-id') || '';
    return id.split('-').pop();
  }

  /* media id -> tone, from alt text on the slide or its thumbnail */
  function toneMap(c) {
    var map = {};
    var nodes = c.section.querySelectorAll('.x-splide-slide[data-media-id], .media-thumbnail[data-media-id]');
    nodes.forEach(function (n) {
      var key = mediaKey(n);
      if (!key || map[key]) return;
      var img = n.querySelector('img');
      var alt = (img && img.getAttribute('alt')) || n.getAttribute('data-dazzolite-alt') || '';
      var tone = toneOf(alt);
      if (tone) map[key] = tone;
    });
    return map;
  }

  var currentTone;
  var skipping = false;

  function allowed(key, map, tone) {
    return !tone || !map[key] || map[key] === tone;
  }

  function findSplide(c) {
    var cands = [c.gallery, document.getElementById('media-gallery-' + c.sid)];
    if (c.gallery) cands.push(c.gallery.parentElement, c.gallery.querySelector('.splide'));
    for (var i = 0; i < cands.length; i++) {
      if (cands[i] && cands[i].splide) return cands[i].splide;
    }
    return null;
  }

  function slideList(c) {
    var s = findSplide(c);
    if (!s) return null;
    try { return { splide: s, slides: s.Components.Slides.get(true) }; } catch (e) { return null; }
  }

  /* No Splide handle available: let the theme switch the image via its own thumbnail click */
  function showFirstAllowedViaThumb(c, map, tone) {
    var activeThumb = c.section.querySelector('.media-thumbnail.media_active[data-media-id]');
    if (activeThumb && allowed(mediaKey(activeThumb), map, tone)) return;
    var thumbs = c.section.querySelectorAll('.media-thumbnail[data-media-id]');
    for (var i = 0; i < thumbs.length; i++) {
      if (allowed(mediaKey(thumbs[i]), map, tone)) {
        var btn = thumbs[i].querySelector('button') || thumbs[i];
        btn.click();
        return;
      }
    }
  }

  function applyTone(force) {
    var c = ctx();
    if (!c || !c.section) return;
    var tone = selectedTone(c);
    var changed = force || tone !== currentTone;
    currentTone = tone;
    var map = toneMap(c);

    if (changed) {
      c.section.querySelectorAll('.media-thumbnail[data-media-id]').forEach(function (t) {
        t.classList.toggle('df-tone-hidden', !allowed(mediaKey(t), map, tone));
      });
    }

    /* Always re-check the main image: the theme starts its slider only after the
       visitor's first scroll/tap, which can be after the metal was applied. */
    var sl = slideList(c);
    if (!sl) { if (changed) showFirstAllowedViaThumb(c, map, tone); return; }
    var active = sl.splide.index;
    var activeSlide = sl.slides.filter(function (o) { return o.index === active; })[0];
    /* metal unchanged and the current slide belongs to it: leave the shopper's choice alone */
    if (!changed && activeSlide && allowed(mediaKey(activeSlide.slide), map, tone)) return;
    /* metal changed (or slide is from another metal): open on that metal's first photo */
    var ok = sl.slides.filter(function (o) { return allowed(mediaKey(o.slide), map, tone); });
    var photo = ok.filter(function (o) { return !o.slide.classList.contains('product-media--video'); })[0];
    var target = photo || ok[0];
    if (target && target.index !== active) { skipping = true; sl.splide.go(target.index); skipping = false; }
  }

  /* arrows / swipe: skip over slides from other metals */
  function bindSplide() {
    var c = ctx();
    var sl = c && slideList(c);
    if (!sl || c.gallery.dataset.dfBound === '1') return !!sl;
    c.gallery.dataset.dfBound = '1';
    sl.splide.on('moved', function (newIndex, prevIndex) {
      if (skipping) return;
      if (sl.splide.index !== newIndex) return; /* a later move already happened */
      var c2 = ctx();
      /* the metal is being changed: applyTone will pick the slide, so don't step here */
      if (selectedTone(c2) !== currentTone) return;
      var map = toneMap(c2);
      var list = slideList(c2).slides;
      var cur = list.filter(function (o) { return o.index === newIndex; })[0];
      if (!cur || allowed(mediaKey(cur.slide), map, currentTone)) return;
      var n = list.length;
      /* Not a one-step arrow/swipe move (e.g. the theme resetting to slide 0 on a variant
         change): open the selected metal's first photo instead of stepping backwards. */
      var oneStep = Math.abs(newIndex - prevIndex) === 1 ||
        (prevIndex === n - 1 && newIndex === 0) || (prevIndex === 0 && newIndex === n - 1);
      if (!oneStep) {
        var ok = list.filter(function (o) { return allowed(mediaKey(o.slide), map, currentTone); });
        var photo = ok.filter(function (o) { return !o.slide.classList.contains('product-media--video'); })[0] || ok[0];
        if (photo) { skipping = true; sl.splide.go(photo.index); skipping = false; }
        return;
      }
      var dir = newIndex > prevIndex || (prevIndex === n - 1 && newIndex === 0) ? 1 : -1;
      for (var step = 1; step < n; step++) {
        var idx = (newIndex + dir * step + n) % n;
        var cand = list.filter(function (o) { return o.index === idx; })[0];
        if (cand && allowed(mediaKey(cand.slide), map, currentTone)) {
          skipping = true; sl.splide.go(idx); skipping = false;
          return;
        }
      }
    });
    return true;
  }


  /* ------------------------- "Pairs well with" add buttons ----------------------- */
  /* Single-option products only (others link to their page). Uses Shopify's native
     /cart/add.js, then refreshes and opens the theme's own cart drawer. */
  function bindPairs() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-df-pairs-add]');
      if (!btn || btn.dataset.busy === '1') return;
      e.preventDefault();
      var msg = document.querySelector('[data-df-pairs-msg]');
      var say = function (t) { if (msg) { msg.textContent = t || ''; msg.hidden = !t; } };
      btn.dataset.busy = '1';
      btn.classList.add('is-loading');
      say('');
      fetch(ROUTE + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Could not add this item to your cart.');
            return data;
          });
        })
        .then(function () {
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 2000);
          try {
            var mini = window.Alpine && Alpine.store('xMiniCart');
            if (mini && mini.reLoad) mini.reLoad();
            if (mini && mini.openCart) mini.openCart();
          } catch (err) { /* cart drawer not available: item is still in the cart */ }
        })
        .catch(function (err) { say(err.message); })
        .then(function () { btn.dataset.busy = ''; btn.classList.remove('is-loading'); });
    });
  }

  /* --------------------------------- wiring ------------------------------------ */
  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      mount();
      bindSplide();
      applyTone(false);
      syncAvailability();
    }, 60);
  }

  function start() {
    bindPairs();
    var tries = 0;
    (function wait() {
      var ok = mount();
      var bound = bindSplide();
      if (ok) applyTone(true);
      if ((!ok || !bound) && tries++ < 50) setTimeout(wait, 120);
    })();

    var c = ctx();
    if (!c || !c.section) return;
    c.section.addEventListener('change', function () { setError(''); refresh(); });
    window.addEventListener('popstate', refresh);
    new MutationObserver(refresh).observe(c.section, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'data-available', 'checked']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
